import { CommonModule } from '@angular/common';
import { Component, computed, effect, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter, map, startWith } from 'rxjs';
import { HomeToolbarComponent } from '../components/home-toolbar/home-toolbar.component';
import { ParentAiService } from '../../parent-ai-assistant/parent-ai.service';
import { FamilyKidsService } from '../../parent-family/services/family-kids.service';
import { UserService } from '../../user/service/user.service';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, RouterOutlet, HomeToolbarComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent {
  #parentAi = inject(ParentAiService);
  #userService = inject(UserService);
  #familyKids = inject(FamilyKidsService);
  #router = inject(Router);

  readonly #currentUrl = toSignal(
    this.#router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map(() => this.#router.url),
      startWith(this.#router.url),
    ),
    { initialValue: this.#router.url },
  );

  readonly showToolbar = computed(() => {
    const url = this.#currentUrl();
    return (
      url.includes('/home/assignments') ||
      url.includes('/home/courses')
    );
  });

  constructor() {
    effect(() => {
      const user = this.#userService.user();
      if (user == null) {
        return;
      }
      this.#parentAi.isVerificationMode.set(!this.#familyKids.hasChildren());
      this.#parentAi.syncInitialChildSelection(this.#familyKids.children());
    });
  }
}
